/**
 * Centralne źródło danych firmowych/kontaktowych NexXsite.
 * Wszystkie komponenty i strony powinny czerpać te dane stąd, zamiast
 * duplikować adres/telefon/e-mail w wielu plikach.
 *
 * Pola w formacie {{NAZWA}} to placeholdery na dane, których jeszcze
 * nie mamy (realne liczby, NIP, współrzędne mapy) — podmienić przed
 * publikacją finalnej wersji.
 */
export const SITE = {
  name: "NexXsite",
  legalName: "NexXsite sp. z o.o.",
  domain: "https://nexxsite.pl",
  nip: "7543364885",

  address: {
    street: "ul. Jana Łangowskiego 4A",
    postalCode: "45-031",
    city: "Opole",
    region: "opolskie",
    country: "PL",
  },

  phone: "+48 509 260 511",
  phoneHref: "tel:+48509260511",
  email: "biuro@nexxsite.pl",
  openingHours: { opens: "09:00", closes: "17:00" },
  description: "Pomagamy firmom usługowym i producentom pozyskiwać zapytania, sprawniej je obsługiwać i mierzyć efekty działań. Łączymy strony WWW, SEO, reklamy i integracje CRM. Pracujemy z Opola dla firm w całej Polsce.",
  hours: "Pon – Pt · 9:00 – 17:00",

  social: {
    facebook: "https://www.facebook.com/profile.php?id=61592765815781",
    instagram: "https://www.instagram.com/nexxsite_pl/",
    linkedin: "https://www.linkedin.com/company/nexxsite/",
  },

  geo: {
    lat: "50.67071537147948",
    lng: "17.9204514768607",
  },
  mapEmbedSrc: "https://www.google.com/maps?q=Jana%20%C5%81angowskiego%204A%2C%2045-031%20Opole&output=embed",
  mapLink: "https://www.google.com/maps?q=ul.+Jana+Łangowskiego+4A,+45-031+Opole",

  // Statystyki placeholderowe do paska w hero / sekcji "O nas" — do uzupełnienia realnymi danymi.
  stats: {
    yearsOnMarket: "2",
    projectsCompleted: "9",
    avgDeployDays: "14-30",
    avgTrafficGrowth: "50-300%",
  },

  // Ceny orientacyjne — jedno miejsce dla wszystkich wzmianek cenowych
  // (Pricing.jsx, FAQ, artykuł na blogu, podstrona /uslugi/strony-internetowe,
  // FAQ usługi Reklamy). Podmień tu, zmiana rozejdzie się wszędzie.
  pricing: {
    start: "2990",
    growth: "1900",
    scale: "7900",
    landingPage: "1990",
    minAdBudget: "2000",
  },

  // Warunki z regulaminu, które wymagają jednorazowej decyzji biznesowej.
  legal: {
    complaintResponseDays: "30",
    noticePeriod: "30",
  },
};

export default SITE;
